let title = '';
const listeners = new Set();

export function getPageTitle() {
    return title;
}

export function setPageTitle(nextTitle) {
    title = nextTitle ?? '';
    listeners.forEach((listener) => listener());
}

export function subscribePageTitle(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
